'use client';
import { useState, useEffect } from 'react';

// 定义窗口尺寸的接口
interface WindowSize {
    width: number;
    height: number;
}

function getSize() {
    if (typeof window === 'undefined') {
        return {
            height: 0,
            width: 0,
        };
    }
    return {
        height: window.innerHeight,
        width: window.innerWidth,
    };
}

const useWindowSize = (): WindowSize => {
    // 使用接口为状态添加类型注解
    const [size, setSize] = useState<WindowSize>(getSize());

    function handleResize() {
        setSize(getSize());
    }

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return size;
};

export default useWindowSize;
